
import { gridQuery, handler, HandlerBody, parseJson, toLowerJson } from '.';
import * as model from '../model';
import { ContactType } from '../model';


export const extensionSearchColumns = ["IExtension.ExtensionNumber", "IExtension.FirstName", "IExtension.LastName",
"IExtension.Expertise", "IExtension.Description"]
export const queueSearchColumns = ['IQueue.ID', 'IQueue.Description']
export const contactSearchColumns = ['IContact.Description', 'IContact.Home',
  'IContact.Mobile',
  'IContact.Business', 'IContact.Email', 'IContact.Company',
  'IContact.Department']
  export const taskSearchColumns = ['ITaskItem.LookupId', 'ITaskItem.Subject']

const propToColumn: Record<string, string | undefined> = {
  description: 'Description',
  business: 'Business',
  mobile: 'Mobile',
  home: 'Home',
  email: 'Email',
}

async function contactHandlerRaw(body: HandlerBody, ucStatus = true) {
  return await handler('/Handlers/Dialogs/ContactDialog.ashx', body, ucStatus)
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
async function contactHandler<T>(body: HandlerBody, ucStatus = true) {
  return parseJson<T>(await contactHandlerRaw(body, ucStatus))
}

export interface Contact {
  ServerName: string
  ContactId: number
  RegionId: string
  ExtensionNumber: string
  Description: string
  Priority: string
  CustomId: string
  Queue: string
  Notes: string
  Url: string
  PagId?: number
  Email: string
  LastAgentCalled: string
  SynchId: string
  SynchDate?: string
  ForeignKey: string
  JobTitle: string
  Department: string
  Company: string
  ImAddress: string
  ImagePath: string
  ImageDate?: string
  IsOutlook: boolean
  Home: string
  Business: string
  Mobile: string
  Other: string
}

export interface KeyValuePair {
  Key: string
  Value: string
}

export async function getContactOptions(myself: model.Identifier, contactId: string, contactType: ContactType, server?: string) {
  const result = await contactHandlerRaw({
    command: 'getoptions',
    extensionid: myself.id,
    servername: server ? server : myself.server,
    id: contactId,
    type: contactType === ContactType.Company ? '0' : contactType === ContactType.Customer ? '-1' : myself.id,
  }, false)

  const r = JSON.parse(result)

  const type = r[0] as KeyValuePair[]
  const priority = r[1] as KeyValuePair[]
  const queue = r[2] as KeyValuePair[]
  const agent = r[3] as KeyValuePair[]
  const c = r[4] !== null ? r[4] as model.Contact : undefined
  const region = toLowerJson(r[5]) as model.Region[]

  //sometimes datastore might get it wrong!!!
  if (!c) {
    return {
      type: type,
      priority: priority,
      queue: queue,
      agent: agent,
      region: region,
      contact: undefined,
    }
  }

  return {
    type: type,
    priority: priority,
    queue: queue,
    agent: agent,
    region: region,
    contact: {
      ServerName: c.ServerName,
      ContactId: c.ContactId,
      RegionId: c.RegionId,
      ExtensionNumber: c.ExtensionNumber,
      Description: c.Description === null ? '' : c.Description,
      Priority: c.Priority,
      CustomId: c.CustomId === null ? '' : c.CustomId,
      Queue: c.Queue === null ? '' : c.Queue,
      Notes: c.Notes === null ? '' : c.Notes,
      Url: c.Url === null ? '' : c.Url,
      PagId: c.PagId === null ? '' : c.PagId,
      Email: c.Email === null ? '' : c.Email,
      LastAgentCalled: c.LastAgentCalled === null ? '' : c.LastAgentCalled,
      SynchId: c.SynchId,
      SynchDate: c.SynchDate,
      ForeignKey: c.ForeignKey,
      JobTitle: c.JobTitle === null ? '' : c.JobTitle,
      Department: c.Department === null ? '' : c.Department,
      Company: c.Company === null ? '' : c.Company,
      ImAddress: c.ImAddress,
      ImagePath: c.ImagePath,
      ImageDate: c.ImageDate,
      IsOutlook: c.IsOutlook,
      Home: c.Home === null ? '' : c.Home,
      Business: c.Business === null ? '' : c.Business,
      Mobile: c.Mobile === null ? '' : c.Mobile,
      Other: c.Other === null ? '' : c.Other,
    } as model.Contact,
  }
}

export async function saveContact(myself: model.Identifier, contact: model.Contact) {
  const id = await contactHandlerRaw({
    command: 'save',
    extensionid: myself.id,
    servername: contact.ServerName,
    data: JSON.stringify(contact),
  }, true)

  return parseInt(id)
}

export async function deleteContact(myself: model.Identifier, contact: model.Identifier) {
  const id = await contactHandlerRaw({
    command: 'delete',
    extensionid: myself.id,
    servername: contact.server,
    id: contact.id,
  }, true)

  return parseInt(id)
}

export type ContactFetchArgs = {
  page: number
  pageSize: number
  orderCol: string
  orderDesc: boolean
  searchText: string
}

export async function getContactsPersonal(myself: model.Identifier, { page, pageSize, orderCol, orderDesc, searchText }: ContactFetchArgs) {
  const grid = await gridQuery('contacts', 'personallist', myself.server, model.EventSubscription.Add, myself.id, '', '', searchText, pageSize, contactSearchColumns, page, propToColumn[orderCol], orderDesc)

  return {
    ...grid, rows: map(grid.rows),
  }
}

export async function getContactsRegion(myself: model.Identifier, regionId: string, type: model.ContactType, { page, pageSize, orderCol, orderDesc, searchText }: ContactFetchArgs) {
  //if (type !== model.ContactType.Company && type !== model.ContactType.Customer) {
    //throw new HttpError(500, 'incorrect type used in this call', '')
  //}

  const grid = await gridQuery('contacts', 'regions', myself.server, model.EventSubscription.Add, regionId, '', type === model.ContactType.Company ? '0' : model.ContactType.Customer ? '-1' : '0', searchText, pageSize, contactSearchColumns, page, propToColumn[orderCol], orderDesc)

  return {
    ...grid, rows: map(grid.rows),
  }
}

export async function getContactFavs(myself: model.Identifier, id: string, { page, pageSize, orderCol, orderDesc, searchText }: ContactFetchArgs) {
  const grid = await gridQuery('contacts', 'favourites', myself.server, model.EventSubscription.Add, id, '', myself.id, searchText, pageSize, contactSearchColumns, page, propToColumn[orderCol], orderDesc)

  return {
    ...grid, rows: map(grid.rows),
  }
}

export async function getContactShortcuts(myself: model.Identifier, page: number) {
  const grid = await gridQuery('contacts', 'shortcuts', myself.server, model.EventSubscription.Add, '', '', myself.id, '', 200, undefined, page)

  return {
    ...grid, rows: map(grid.rows),
  }
}

export async function getContactsByIds({ server, id }: model.Identifier,contactIds: model.Identifier[]) {
  let ids = ''
  contactIds.forEach(x => {
    ids += x.server + '|' + x.id + ','
  });
  const grid = await gridQuery('contacts', 'list', server, model.EventSubscription.Add, '', ids, id, '', 200)

  return {
    ...grid, rows: map(grid.rows),
  }
}

function map(rows: any[]) {
  return rows.map<model.ContactBasic>(row => ({
    server: row.serverName,
    id: row.contactId.toString(),
    regionId: row.regionId,
    extensionNumber: row.extensionNumber,
    description: row.description,
    email: row.email,
    home: row.home,
    business: row.business,
    mobile: row.mobile,
    other: row.other,
  }))
}
